/**!
 * Created by Leonardo Cheslacki on 06/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import AnimateController from './../AnimateController';

import Big from 'big.js';

import config from '../../../../config';

const {default: {app_name, iframe, external, fullscreen}, menu: {index}} = config;

let _this = {};

/**
 *
 */
class PageController extends AnimateController {
    /**
     *
     */
    constructor() {
        super();

        _this = this;
    };

    $functionsPage = {
        /**
         *
         * @param event
         * @param _this_frame
         * @param big_start
         * @param big_end
         * @param callback
         */
        handleMarkerSlider: function (event, {_this_frame, big_start, big_end, callback}) {
            const
                {occ_marker_slider} = _this_frame,
                end_x = _this.bigToNumber(big_end);

            if (big_start.eq(big_end)) {
                _this.setCoordinateTransform(occ_marker_slider, end_x);

                (typeof (callback) === 'function') && callback(true);
            } else if (big_start.lte(big_end)) {
                let
                    big_distance = big_end.minus(big_start).div(_this.$controller.big_2).plus(big_start),
                    big_slider_x = (new Big(occ_marker_slider.x));

                if (big_slider_x.lte(big_distance)) {
                    _this.main.$speed_marker_slider = (_this.main.$speed_marker_slider.plus(_this.$controller.big_1));
                } else if (big_slider_x.gte(big_distance)) {
                    // _this.main.$speed_marker_slider = (_this.main.$speed_marker_slider.minus(_this.$controller.big_1));
                }

                big_slider_x = big_slider_x.plus(_this.main.$speed_marker_slider);

                _this.setCoordinateTransform(occ_marker_slider, _this.bigToNumber(big_slider_x));

                if (big_slider_x.gte(big_end)) {
                    _this.setCoordinateTransform(occ_marker_slider, end_x);

                    _this.main.$speed_marker_slider = _this.$controller.big_0;

                    (typeof (callback) === 'function') && callback(true);
                }
            } else if (big_start.gte(big_end)) {
                let
                    big_distance = big_start.minus(big_end).div(_this.$controller.big_2).plus(big_end),
                    big_slider_x = (new Big(occ_marker_slider.x));

                if (big_slider_x.gte(big_distance)) {
                    _this.main.$speed_marker_slider = (_this.main.$speed_marker_slider.plus(_this.$controller.big_1));
                } else if (big_slider_x.lte(big_distance)) {
                    // _this.main.$speed_marker_slider = (_this.main.$speed_marker_slider.minus(_this.$controller.big_1));
                }

                big_slider_x = big_slider_x.minus(_this.main.$speed_marker_slider);

                _this.setCoordinateTransform(occ_marker_slider, _this.bigToNumber(big_slider_x));

                if (big_slider_x.lte(big_end)) {
                    _this.setCoordinateTransform(occ_marker_slider, end_x);

                    _this.main.$speed_marker_slider = _this.$controller.big_0;

                    (typeof (callback) === 'function') && callback(true);
                }
            } else {
                _this.setCoordinateTransform(occ_marker_slider, end_x);

                (typeof (callback) === 'function') && callback(true);
            }

            occ_marker_slider.stage.update();
        }
    };

    fullScreen = () => {
        const {size, logo, confirm, cancel, type} = fullscreen;

        if (jQuery.isFunction(jQuery.fn.confirm)) {
            const object_confirm = !confirm.disabled ? {
                confirm: {
                    text: confirm.text,
                    btnClass: confirm.class,
                    action: () => {
                        if (type === 'fullscreen') {
                            this.openFullScreen();
                            // if(type === 'fullscreen'){
                            //     const element_img = document.createElement('IMG');
                            //
                            //     this.setAttributes(element_img, {
                            //         id: 'close_overlay_container',
                            //         alt: 'close',
                            //         src: this.getUriImage('360/windowed.png'),
                            //         width: this.calcSize(1, stage.scaleX, 40, false, 'int'),
                            //         height: this.calcSize(1, stage.scaleY, 40, false, 'int')
                            //     });
                            //
                            //     const close = () => {
                            //         this.closeFullScreen();
                            //         this.removeListener('click', 'click-close-overlay-container', () => {
                            //             element_img.remove();
                            //         });
                            //     }
                            //
                            //     this.removeListener('click', 'click-close-overlay-container', () => {
                            //         this.addListener(element_img, 'click', 'click-close-overlay-container', close);
                            //     });
                            //
                            //     anim_container.appendChild(element_img);
                            // }
                        } else if (type === 'audio') {
                            this.setState({...this.state, confirm: true}, () => {
                                this.main.emit('play_audio', {}, 'confirm_play_audio', true);
                            });
                        }
                    }
                }
            } : {};

            const object_cancel = !cancel.disabled ? {
                cancel: {
                    text: cancel.text,
                    btnClass: cancel.class,
                    action: this._void
                }
            } : {};

            jQuery.confirm({
                ...fullscreen.options,
                title: `<img width="${size.width}" height="${size.height}" src="${this.getUriImage(logo)}" alt="logo-confirm"/>`,
                buttons: {...object_confirm, ...object_cancel}
            });
        }
    };

    /**
     *
     * @param occurrence
     * @param object
     * @param callback
     */
    openExternal = (occurrence, object, callback) => {
        const
            name = this.getObject(object, 'name'),
            uri = this.getObject(object, 'uri');

        const execute = () => {
            let
                {properties: {width, height}} = this.getComposition('index').getLibrary(),
                left = ((width - external.size.width) / 2),
                top = ((height - external.size.height) / 2),
                features = `toolbar=${external.attributes.toolbar}, location=${external.attributes.location}, menubar=${external.attributes.menubar}, width=${external.size.width}, height=${external.size.height}, left=${left}, top=${top}`;

            const _blank = window.top.open(uri, '_blank', features);

            let
                html_icon = `<link rel="shortcut icon" type="image/x-icon" href="${this.getUriImage('icons/favicon.ico')}">`,
                html_style = `<link media="all" type="text/css" rel="stylesheet" href="${this.getUriCss('app.min.css')}">`,
                html_title = `<title>:: ${app_name} ::</title>`,
                html_head = `<head>${html_title}${html_icon}${html_style}</head>`,
                html_iframe = `<iframe src="${uri}" id="window_iframe" width="100%" height="100%" allowfullscreen="0" scrolling="no" frameborder="0"></iframe>`,
                html_close = `<img onclick="windowClose();" src="${this.getUriImage('close.png')}" width="40" height="40" id="window_close" alt="close">`,
                html_fullscreen = `<img onclick="windowFullScreen();" src="${this.getUriImage('360/fullscreen.png')}" width="40" height="40" id="window_fullscreen" alt="open">`,
                html_script = `<script src="${this.getUriJs('window-blank.min.js')}"></script>`,
                html_body = `<body>${html_iframe}${html_close}${html_fullscreen}${html_script}</body>`;

            let html = `${html_head}${html_body}`;

            _blank.document.write(html);

            const close =  () => {
                _blank.close();
            };

            this.throttle('back-write', () => {
                this.removeListener('click', 'click-close-blank-top', () => {
                    this.addListener(window.top, 'click', 'click-close-blank-top', close);
                });

                this.removeListener('click', 'click-close-blank-load-iframe', () => {
                    this.addListener(window.top[0], 'click', 'click-close-blank-load-iframe', close);
                });
            }, 500);

            const beforeunload = () => {
                if (this.isEmpty(occurrence)) {
                    this.main.$default_page();
                    this.main.emit('animate_end', {}, name);
                }
            };

            this.removeListener('beforeunload', `beforeunload-blank`, () => {
                this.addListener(_blank, 'beforeunload', `beforeunload-blank`, beforeunload);
            });

            (typeof (callback) === 'function') && callback(true);
        };

        if (!this.isEmpty(occurrence)) {
            let slug = this.toSlug(name);
            this.removeListener('click', `click-open-external-${slug}`, () => {
                this.addListener(occurrence, 'click', `click-open-external-${slug}`, execute);
            });
        } else {
            execute();
        }
    };

    /**
     *
     * @param occurrence
     * @param object
     * @param callback
     */
    openTour = (occurrence, object, callback) => {
        const
            name = this.getObject(object, 'name'),
            uri = this.getObject(object, 'uri');

        const execute = () => {
            const
                anim_container = document.getElementById('animation_container'),
                {properties: {width, height}} = this.getComposition('index').getLibrary(),
                element_iframe = document.createElement('IFRAME'),
                element_img = document.createElement('IMG');

            this.setAttributes(element_iframe, {
                ...iframe.attributes,
                src: uri,
                id: 'dom_overlay_container',
                class: 'animate__animated animate__fadeIn',
                width: this.calcSize(width, anim_container.clientWidth, width, false, 'int'),
                height: this.calcSize(height, anim_container.clientHeight, height, false, 'int')
            });

            this.setAttributes(element_img, {
                id: 'close_overlay_container',
                alt: 'close',
                src: this.getUriImage('close.png'),
                width: this.calcSize(1, stage.scaleX, 40, false, 'int'),
                height: this.calcSize(1, stage.scaleY, 40, false, 'int')
            });

            const close = () => {
                this.setAttributes(element_iframe, {class: 'animate__animated animate__fadeOut'});
            };

            const animateEnd = ({animationName}) => {
                if (animationName === 'fadeOut') {
                    if (this.isEmpty(occurrence)) {
                        this.main.$default_page();
                        this.main.emit('animate_end', {}, name);
                    }

                    this.removeListener('animationend', 'animationend-tour', () => {
                        element_iframe.remove();
                    });

                    this.removeListener('click', 'click-close-overlay-container', () => {
                        element_img.remove();
                    });
                }
                (typeof (callback) === 'function') && callback(animationName);
            };

            this.removeListener('animationend', 'animationend-tour', () => {
                this.addListener(element_iframe, 'animationend', 'animationend-tour', animateEnd);
            });

            this.removeListener('click', 'click-close-overlay-container', () => {
                this.addListener(element_img, 'click', 'click-close-overlay-container', close);
            });

            anim_container.appendChild(element_iframe);

            anim_container.appendChild(element_img);
        };

        if (!this.isEmpty(occurrence)) {
            let slug = this.toSlug(name);
            this.removeListener('click', `click-open-tour-${slug}`, () => {
                this.addListener(occurrence, 'click', `click-open-tour-${slug}`, execute);
            });
        } else {
            execute();
        }
    };

    /**
     *
     * @param occurrence
     * @param object
     * @param callback
     */
    openVideo = (occurrence, object, callback) => {
        const
            name = this.getObject(object, 'name'),
            uri = this.getObject(object, 'uri');

        const execute = () => {
            const
                anim_container = document.getElementById('animation_container'),
                {properties: {width, height}} = this.getComposition('index').getLibrary(),
                element_video = document.createElement('VIDEO'),
                element_source = document.createElement('SOURCE'),
                element_img = document.createElement('IMG');

            this.setAttributes(element_video, {
                id: 'dom_overlay_container',
                class: 'animate__animated animate__fadeIn',
                width: this.calcSize(1, stage.scaleX, width, false, 'int'),
                height: this.calcSize(1, stage.scaleY, height, false, 'int')
            });

            this.setAttributes(element_source, {
                src: uri,
                id: 'source_overlay_container',
                type: 'video/mp4'
            });

            this.setAttributes(element_img, {
                id: 'close_overlay_container',
                alt: 'close',
                src: this.getUriImage('close.png'),
                width: this.calcSize(1, stage.scaleX, 40, false, 'int'),
                height: this.calcSize(1, stage.scaleY, 40, false, 'int')
            });

            const close = () => {
                this.setAttributes(element_video, {class: 'animate__animated animate__fadeOut'});
            };

            const play = () => {
                element_video.play();
            };

            const animateEnd = ({animationName}) => {
                if (animationName === 'fadeOut') {
                    if (this.isEmpty(occurrence)) {
                        this.main.$default_page();
                        this.main.emit('animate_end', {}, name);
                    }

                    this.removeListener('animationend', 'animationend-video', () => {
                        element_video.remove();
                    });

                    this.removeListener('click', 'click-close-overlay-container', () => {
                        element_img.remove();
                    });
                }
                (typeof (callback) === 'function') && callback(animationName);
            };

            this.removeListener('loadedmetadata', 'load-video', () => {
                this.addListener(element_video, 'loadedmetadata', 'load-video', play);
            });

            this.removeListener('ended', 'ended-video', () => {
                this.addListener(element_video, 'ended', 'ended-video', close);
            });

            this.removeListener('animationend', 'animationend-video', () => {
                this.addListener(element_video, 'animationend', 'animationend-video', animateEnd);
            });

            this.removeListener('click', 'click-close-overlay-container', () => {
                this.addListener(element_img, 'click', 'click-close-overlay-container', close);
            });

            element_video.appendChild(element_source);

            anim_container.appendChild(element_video);

            anim_container.appendChild(element_img);
        };

        if (!this.isEmpty(occurrence)) {
            let slug = this.toSlug(name);
            this.removeListener('click', `click-open-video-${slug}`, () => {
                this.addListener(occurrence, 'click', `click-open-video-${slug}`, execute);
            });
        } else {
            execute();
        }
    };

    /**
     *
     * @returns {*}
     */
    getCurrentIndex = (paginates = []) => {
        let
            data = [],
            current_name = null;

        if (this.isArrayIf(paginates)) {
            data = paginates;
            current_name = this.main.$current_name_sub;
        } else {
            data = index;
            current_name = this.main.$current_name;
        }

        return data.find(({name}) => (name === current_name));
    };

    /**
     *
     * @param paginates
     * @returns {unknown}
     */
    getDefaultIndex = (paginates = []) => {
        let data = this.isArrayIf(paginates) ? paginates : index;
        return data.find((object) => (this.getObject(object, 'default')));
    };

    pageIn = () => {
        this.getFrame(this.get(this.main.$current_name)).gotoAndPlay('start');
    };

    pageOut = () => {
        this.getFrame(this.get(this.main.$current_name)).gotoAndPlay('complete');
    };

    logo = () => {
        const
            {occ_logo} = this.getFrame(),
            object = this.getCurrentIndex() || this.getDefaultIndex(),
            logo = this.getObject(object, 'logo');

        switch (logo) {
            case 'small':
                occ_logo.gotoAndStop(logo);
                occ_logo.visible = true;
                break;
            case 'medium':
                occ_logo.gotoAndStop(logo);
                occ_logo.visible = true;
                break;
            case 'large':
                occ_logo.gotoAndStop(logo);
                occ_logo.visible = true;
                break;
            default:
                occ_logo.gotoAndStop('none');
                occ_logo.visible = false;
        }
    };

    backgroundDynamic = () => {
        const
            {occ_dynamic} = this.getFrame(),
            object = this.getCurrentIndex() || this.getDefaultIndex();

        if (this.getObject(object, 'dynamic')) {
            this.gotoAndStopFrame(occ_dynamic, this.main.$current_frame);
            occ_dynamic.visible = true;
        } else {
            occ_dynamic.visible = false;
        }
    };

    markerIn = () => {
        const {occ_marker} = this.getFrame();

        this.gotoAndStopFrame(occ_marker, this.main.$current_frame);

        occ_marker.occ_animate.gotoAndPlay('start');
    };

    markerOut = () => {
        const {occ_marker} = this.getFrame();

        this.gotoAndStopFrame(occ_marker, this.main.$current_frame);

        occ_marker.occ_animate.gotoAndPlay('complete');
    };

    markerSliderIn = () => {
        const {occ_marker_slider} = this.getFrame();

        occ_marker_slider.visible = true;
    };

    /**
     *
     * @param btn
     */
    markerSliderAnimate = (btn) => {
        this.destroyTicker('_handleSlideHours');
        this.destroyTicker('_handleSlider');
        this.destroyTicker('_handleZoom');
        this.destroyTicker('_handleMarkerSlider');

        const
            _this_frame = this.getFrame(),
            {occ_marker_slider} = _this_frame,
            big_start = (new Big(occ_marker_slider.x)),
            big_end = (new Big(btn.x));

        this.main.$speed_marker_slider = this.$controller.big_0;

        createjs.Ticker.timingMode = createjs.Ticker.RAF;

        let ticker = createjs.Ticker.on('tick', this.$functionsPage.handleMarkerSlider, false, false, {
            _this_frame: _this_frame,
            big_start: big_start,
            big_end: big_end,
            callback: () => this.destroyTicker('_handleMarkerSlider')
        });

        this.setReferenceTicker('_handleMarkerSlider', ticker);
    };
}

export default PageController;
